import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header-text-icon',
  standalone: true,
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './header-text-icon.component.html',
  styleUrls: ['./header-text-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderTextIconComponent {}
